const CUSTOMER_STATUS_LABELS: Record<string, Record<string, string>> = {
  pt: { APPROVED: 'Aprovado', PENDING: 'Pendente', REJECTED: 'Rejeitado', UPDATE_PENDING: 'Alteração pendente', UPDATE_APPROVED: 'Alteração aprovada', UPDATE_REJECTED: 'Alteração rejeitada' },
  en: { APPROVED: 'Approved', PENDING: 'Pending', REJECTED: 'Rejected', UPDATE_PENDING: 'Change pending', UPDATE_APPROVED: 'Change approved', UPDATE_REJECTED: 'Change rejected' },
  es: { APPROVED: 'Aprobado', PENDING: 'Pendiente', REJECTED: 'Rechazado', UPDATE_PENDING: 'Cambio pendiente', UPDATE_APPROVED: 'Cambio aprobado', UPDATE_REJECTED: 'Cambio rechazado' },
};

/**
 * Converts the status codes used by the API into Portuguese (Portugal) labels.
 * The original code must continue to be used in requests and business logic.
 */
export const getCustomerStatusLabel = (
  status?: string | null,
  fallback = 'Desconhecido',
  language = 'pt'
) => {
  if (!status) return fallback;

  const labels = CUSTOMER_STATUS_LABELS[language] || CUSTOMER_STATUS_LABELS.pt;
  return labels[status.trim().toUpperCase()] || fallback;
};
